<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <DemoBoard :isPublic="false"></DemoBoard>
    </div>
</template>

<script>
    import DemoBoard from "../../components/parametric-search/DemoBoard";
    //TODO DemoBoard is undefined if /views/parametric-sarch/DemoBoard.vue is registered in parametric-router.js

    export default {
        name: "MyParametricDemo",
        components: {
            DemoBoard
        }
    }
</script>
